<template>
  <section>
    <v-row>
      <v-col
        cols="12" sm="6" lg="3"
        v-for="(item, index) in cartas"
        :key="index"
      >
        <v-card
          class="v-card--material pa-3 v-card--material-stats theme--light v-card--material--has-heading d-flex flex-column"
          height="100%"
        >
          <div class="d-flex align-center">
            <v-sheet
              :color="item.color"
              class="text-start v-card--material__heading elevation-6 pa-7 d-flex align-center justify-center"
              style="max-height: 70px;"
            >
              <v-icon large color="white">
                {{ item.icono }}
              </v-icon>
            </v-sheet>
            <div class="ml-4 flex-grow-1" style="min-width: 0;">
              <div class="text-right">
                <div class="body-3 grey--text font-weight-light">
                  {{ item.nombre }}
                </div>
                <h3 class="headline font-weight-bold text--primary">
                  {{ item.total }}
                  <small></small>
                </h3>
              </div>
            </div>
          </div>
          <!-- Espacio adicional para empujar el contenido hacia abajo si es necesario y ayudar a la alineación -->
          <v-spacer></v-spacer>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>
<script>
export default {
  name: "CartasPersonalizadas",
  props: ["cartas"],
};
</script>



// WEBPACK FOOTER //
// src/components/Dialogos/CartasPersonalizadas.vue